<template>
  <div class="-mt-10">
    <div
      v-if="pendingAssetDeposits.length > 0"
      class="flex items-center justify-center mt-20 border-t relative"
    >
      <h2
        class="text-lg font-semibold bg-root-1 absolute -top-8 left-6/12 px-14 py-4 border-none outline-none"
      >
        Pending Transfers
      </h2>
      <ul class="mt-10 w-full max-h-64 overflow-y-scroll">
        <li
          v-for="deposit in pendingAssetDeposits"
          :key="deposit.id"
          class="flex items-center mb-6 justify-between w-full bg-root-2 px-2 py-3 shadow-xs rounded-2xl cursor-pointer"
          @click="openDepositWallet(deposit)"
        >
          <span class="flex gap-x-3">
            <currency-icons
              :currency="
                deposit.amount.currency === 'USDC'
                  ? 'usdc-ethereum'
                  : 'usdt-ethereum'
              "
            />
            <span class="text-xs font-light flex flex-col">
              <span class="font-semibold capitalize">Deposit</span>
              <span>{{
                $dayjs(deposit.createdAt).format('DD, MMM YYYY')
              }}</span>
            </span>
            <span
              class="text-xs font-light border rounded-xl h-5 px-2 text-yellow-10 border-yellow-10 capitalize"
              >Pending</span
            >
          </span>
          <span class="flex items-center flex-col">
            <span class="font-semibold text-xs"
              >+{{ deposit.amount.amount }} {{ deposit.amount.currency }}</span
            >
            <span class="font-light text-xs"
              >+{{ deposit.amount.amount }} {{ deposit.amount.currency }}</span
            >
          </span>
        </li>
      </ul>
    </div>
    <deposit-Wallet
      v-if="showDepositWalletDialog"
      :view="dialogView"
      :showDialog="showDepositWalletDialog"
      @closeDialog="closeDepositWalletDialog"
      @showMakePayment="goToMakePayment"
    />
  </div>
</template>

<script>
import transferDetails from '@/mixins/localDeposit.js'
export default {
  mixins: [transferDetails],
  components: {
    CurrencyIcons: () => import('@/assets/icons/CurrencyIcons.vue'),
    DepositWallet: () =>
      import('@/components/terminal/dialogs/DepositWallet.vue')
  },
  data () {
    return {
      showDepositWalletDialog: false,
      dialogView: ''
    }
  },
  computed: {
    pendingAssetDeposits () {
      return this.$store.state.transactions.deposits.items.slice(0, 10)
    },
    walletAddresses () {
      return this.$store.state.transactions.walletAddresses.items || []
    }
  },
  methods: {
    closeDepositWalletDialog () {
      this.showDepositWalletDialog = false
    },
    goToMakePayment () {
      this.$emit('showDebitedAmount')
    },
    openDepositWallet (deposit) {
      const vm = this
      const walletDetails = this.walletAddresses.find(
        (wallet) =>
          wallet.asset === deposit.amount.currency &&
          wallet.reason === 'transfer'
      )
      if (!walletDetails) {
        vm.$message({
          showClose: true,
          message: `Business is yet to register ${deposit.amount.currency} for asset deposit`,
          type: 'info'
        })
      } else {
        const details = {
          debitAmount: deposit.amount.amount
        }
        this.$store.dispatch('terminal/setTransferDetails', details)
        this.$store.dispatch('terminal/setAssetDepositId', deposit.id)
        if (deposit.amount.currency === this.secondaryCurrency) {
          this.$store.dispatch(
            'common/setSecondaryCurrency',
            this.activeCurrency
          )
        }
        this.$store.dispatch(
          'common/setActiveCurrency',
          deposit.amount.currency
        )
        this.$store.dispatch('terminal/hasBeenDebited', true)
        this.$emit('showDebitedAmount')
      }
    }
  },
  mounted () {
    if (this.pendingAssetDeposits.length === 1) {
      this.openDepositWallet(this.pendingAssetDeposits[0])
    }
  }
}
</script>

<style></style>
